import ContextBase from '@ckeditor/ckeditor5-core/src/context';

export class Context extends ContextBase {}
Context.builtinPlugins = [];
